import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

declare global {
    interface Window {
        Pusher: typeof Pusher
    }
}

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()

    if (!config.public.reverb.key) {
        return { provide: { echo: null } }
    }

    window.Pusher = Pusher

    const echo = new Echo({
        broadcaster: 'reverb',
        key: config.public.reverb.key,
        wsHost: config.public.reverb.host,
        wsPort: config.public.reverb.port,
        wssPort: config.public.reverb.port,
        forceTLS: config.public.reverb.scheme === 'https',
        enabledTransports: ['ws', 'wss'],
        // Channel authorization goes through the BFF, which holds the API token.
        authEndpoint: '/api/broadcasting/auth',
    })

    return {
        provide: {
            echo,
        },
    }
})
